import styled from 'styled-components'

import { FavoriteHeart } from '../../../../Icons/components'

interface Props {
  active: boolean
}

const StyledFavoriteHeart = styled(FavoriteHeart).withConfig({
  shouldForwardProp: (prop: any) => prop !== 'active',
})<Props>`
  path {
    fill-rule: ${({ active }) => (active ? 'nonzero' : 'evenodd')};
  }

  &:hover {
    path {
      fill-rule: ${({ active }) => (!active ? 'nonzero' : 'evenodd')};
    }
  }
`

export default StyledFavoriteHeart
